module.exports = __webpack_public_path__ + "static/media/forest.52311a71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/forest.png
// module id = 645
// module chunks = 0